import {createSlice} from "@reduxjs/toolkit";

const initialCoursesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  courseForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const coursesSlice = createSlice({
  name: "courses",
  initialState: initialCoursesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCourseById
    courseFetched: (state, action) => {
      state.actionsLoading = false;
      state.courseForEdit = action.payload.courseForEdit;
      state.error = null;
    },
    // findCourses
    coursesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createCourse
    courseCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.course);
    },
    // updateCourse
    courseUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.courseId === action.payload.course.courseId) {
          return action.payload.course;
        }
        return entity;
      });
    },
    // deleteCourse
    courseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.courseId !== action.payload.courseId);
    },
    // deleteCourses
    coursesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.courseId)
      );
    },
  }
});
